'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/list/style/css.web.js
// module id = 260
// module chunks = 0